<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2><a href="/trials"><i class="fa fa-angle-double-left"></i></a>Burnrate Info</h2>
        <strong>{{ this.initTrial.country.name }}, {{ this.initTrial.user.name }}</strong><br>
        <strong>{{ this.initTrial.formattedStartDate }} ({{ this.initTrial.test_period }} {{ type === 'trial' ? 'Months' : 'Years' }})</strong>
      </div>
      <burn-rate-table
        :init-trial="initTrial"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      initTrial: null,
      type: {
        default: 'trial'
      },
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      addMonth() {
        axios.post(`/trials/${this.initTrial.id}/burn_rates`).then(({data}) => {
          window.location.reload()
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/burnrates/BurnRateIndex.vue